import React from "react";

/* COMPONENTS */
import Modal from "../common_modal/Modal";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/* PICTURES & ICONS */
import map_2d from "../../Assets/png_jpg/map_2d.png";
import map_3d from "../../Assets/png_jpg/map_3d.png";
import map_light from "../../Assets/png_jpg/map_light.png";
import map_dark from "../../Assets/png_jpg/map_dark.png";
import map_sat_square from "../../Assets/png_jpg/map_sat_square.png";
import ICON_LEGEND from "../../Assets/jsx/ICON_LEGEND";
import ICON_GLOBE from "../../Assets/jsx/ICON_GLOBE";
import ICON_MERCATOR from "../../Assets/jsx/ICON_MERCATOR";

const MAP_MODALS = ({
  // Share Props
  modal_share,
  toggle_share_modal,
  shareLink,
  copy_status,
  handle_copy_link,

  // GPS Error Props
  modal_error_gps,
  toggle_error_gps,
  dict,
  language,
  gps_error_message,
  error_string,
  browser_info,
  on_reload_browser,

  // Settings Menu Props
  anchor,
  modal_setting,
  on_close_setting,
  on_set_style_map,
  basemap_used,
  on_change_projection,
  projection,
  language_list,
  on_set_lang,
  legend_status,
  toggle_legend,
  is_show_feedback_button,
  toggle_feedback_setting_button,

  // Tour Guide Prop
  startGuide,
}) => {
  return (
    <>
      {modal_share && (
        <Modal
          modalSize="small"
          isOpen={modal_share}
          onClose={toggle_share_modal}
          title="Share project"
        >
          <div className="box-body" id="box-body">
            <p
              className="container background_grey_light text_medium margin_bottom"
              style={{ wordBreak: "break-all" }}
            >
              {shareLink}
            </p>
            <button
              className={`button ${copy_status ? "background_green" : "background_black"}`}
              onClick={handle_copy_link}
            >
              {copy_status ? "Copied!" : "Copy"}
            </button>
          </div>
        </Modal>
      )}

      {modal_error_gps && (
        <Modal
          modalSize="small"
          isOpen={modal_error_gps}
          onClose={toggle_error_gps}
        >
          <div className="box-body" id="box-body">
            <h3 className="margin_bottom">
              {
                dict?.[
                  "Location retrieval from browser failed, error description:"
                ]?.[language]
              }
            </h3>
            <div className="container_light background_red_bright margin_bottom">
              {gps_error_message}
            </div>
            <div
              className="container_light background_red_bright margin_bottom"
              style={{ wordBreak: "break-all" }}
            >
              {error_string}
            </div>
            <table className="table margin_bottom">
              <tbody>
                <tr>
                  <td>{dict?.["Browser name"]?.[language]}</td>
                  <td>{browser_info.browser_name}</td>
                </tr>
                <tr>
                  <td>{dict?.["Browser engine"]?.[language]}</td>
                  <td>{browser_info.browser_engine}</td>
                </tr>
                <tr>
                  <td>{dict?.["Operating System"]?.[language]}</td>
                  <td>{browser_info.os_name}</td>
                </tr>
                <tr>
                  <td>{dict?.["OS Version"]?.[language]}</td>
                  <td>{browser_info.os_version}</td>
                </tr>
              </tbody>
            </table>
            <h3 className="margin_bottom">
              {
                dict?.[
                  "Please allow your browser to retrieve your location, or"
                ]?.[language]
              }
            </h3>
            <button
              className="button background_black margin_right margin_bottom"
              onClick={on_reload_browser}
            >
              {dict?.["Reload the page"]?.[language]}
            </button>
          </div>
        </Modal>
      )}

      {/* --- SETTINGS MENU --- */}
      <FLOAT_MENU
        anchorEl={anchor}
        open={modal_setting}
        onClose={on_close_setting}
      >
        <div style={{ width: "251px" }} className="noselect">
          <h1 className="text_bold margin_top">Map Control Center</h1>
          <br />
          <section className="container background_grey_light margin_bottom container_base_map_style">
            <div className="text_choose text_medium">Style Basemap</div>
            <div className="base_1">
              <img
                className="cursor_pointer"
                onClick={() => on_set_style_map("2d")}
                data-mapid="clickBaseMap"
                alt="base_1"
                src={map_2d}
                style={{
                  height: "37px",
                  verticalAlign: "middle",
                  borderRadius: "7px",
                  border: `5px solid ${basemap_used === "2d" ? "#000" : "#dedede"}`,
                }}
              />
            </div>
            <div className="base_2">
              <img
                className="cursor_pointer"
                onClick={() => on_set_style_map("3d")}
                data-mapid="click3dMap"
                alt="base_2"
                src={map_3d}
                style={{
                  height: "37px",
                  verticalAlign: "middle",
                  borderRadius: "7px",
                  border: `5px solid ${basemap_used === "3d" ? "#000" : "#dedede"}`,
                }}
              />
            </div>
            <div className="base_3">
              <img
                className="cursor_pointer"
                onClick={() => on_set_style_map("light")}
                data-mapid="clickLightMap"
                alt="base_3"
                src={map_light}
                style={{
                  height: "37px",
                  verticalAlign: "middle",
                  borderRadius: "7px",
                  border: `5px solid ${basemap_used === "light" ? "#000" : "#dedede"}`,
                }}
              />
            </div>
            <div className="base_4">
              <img
                className="cursor_pointer"
                onClick={() => on_set_style_map("dark")}
                data-mapid="clickDarkMap"
                alt="base_4"
                src={map_dark}
                style={{
                  height: "37px",
                  verticalAlign: "middle",
                  borderRadius: "7px",
                  border: `5px solid ${basemap_used === "dark" ? "#000" : "#dedede"}`,
                }}
              />
            </div>
            <div className="base_5">
              <img
                className="cursor_pointer"
                onClick={() => on_set_style_map("sat")}
                data-mapid="clickSateliteMap"
                alt="base_5"
                src={map_sat_square}
                style={{
                  height: "37px",
                  verticalAlign: "middle",
                  borderRadius: "7px",
                  border: `5px solid ${basemap_used === "sat" ? "#000" : "#dedede"}`,
                }}
              />
            </div>
          </section>

          <section className="two_container_equal margin_bottom">
            <div className="container background_grey_light">
              <p className="text_medium  margin_bottom">
                {dict?.["Map Projection"]?.[language] || "Map Projection"}
              </p>
              <div className="two_container_equal">
                <div
                  className="cursor_pointer"
                  onClick={() => on_change_projection("mercator")}
                  style={{
                    height: "36px",
                    width: "36px",
                    borderRadius: "18px",
                    backgroundColor:
                      projection === "mercator" ? "#000" : "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <ICON_MERCATOR
                    style={{ height: "20px" }}
                    color={projection === "mercator" ? "#fff" : "#000"}
                  />
                </div>
                <div
                  className="cursor_pointer"
                  onClick={() => on_change_projection("globe")}
                  style={{
                    height: "36px",
                    width: "36px",
                    borderRadius: "18px",
                    backgroundColor: projection === "globe" ? "#000" : "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <ICON_GLOBE
                    style={{ height: "20px" }}
                    color={projection === "globe" ? "#fff" : "#000"}
                  />
                </div>
              </div>
            </div>

            <div className="container background_grey_light">
              <p className="text_medium  margin_bottom">
                {dict?.["Language"]?.[language] || "Language"}
              </p>
              <div className="two_container_equal">
                {language_list?.map((item, idx) => {
                  return (
                    <div
                      key={idx}
                      className="cursor_pointer"
                      onClick={() => on_set_lang(item.value)}
                      data-mapid={`clickChangeLanguage-${item.value}`}
                      style={{
                        height: "36px",
                        width: "36px",
                        borderRadius: "18px",
                        backgroundColor:
                          language === item.value ? "#000" : "#fff",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        className="cursor_pointer"
                        style={{ height: "15px" }}
                        alt={item.name}
                        src={item.image}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </section>

          <div style={{ display: "flex", gap: "10px" }}>
            <div
              className="container background_grey_light two_container_auto control_center cursor_pointer"
              style={{ height: "60px", width: "50%" }}
              onClick={toggle_legend}
            >
              <div
                style={{
                  height: "36px",
                  width: "36px",
                  borderRadius: "18px",
                  backgroundColor: legend_status ? "#000" : "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ICON_LEGEND
                  style={{ height: "15px" }}
                  color={legend_status ? "#fff" : "#000"}
                />
              </div>
              <p className="text_medium">Legenda</p>
            </div>

            <div
              className="container background_grey_light two_container_auto control_center cursor_pointer"
              style={{ height: "60px", width: "50%" }}
              onClick={toggle_feedback_setting_button}
            >
              <div
                style={{
                  height: "36px",
                  width: "36px",
                  borderRadius: "18px",
                  backgroundColor:
                    is_show_feedback_button !== false ? "#000" : "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke={is_show_feedback_button !== false ? "#fff" : "#000"}
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                  <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
              </div>
              <p className="text_medium">Feedback</p>
            </div>
          </div>

          <div style={{ marginTop: "15px", textAlign: "center" }}>
            <button
              className="button background_black full_width"
              onClick={() => {
                startGuide();
                on_close_setting();
              }}
            >
              Replay Guide
            </button>
          </div>
        </div>
      </FLOAT_MENU>
    </>
  );
};

export default MAP_MODALS;
